/** Imagen de relleno (SVG en línea) para productos o categorías sin foto. */
export const PLACEHOLDER_IMG =
  "data:image/svg+xml;utf8," +
  encodeURIComponent(
    `<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 160 160'><rect width='160' height='160' fill='#efede6'/><g fill='none' stroke='#b9b5a8' stroke-width='5' stroke-linecap='round' stroke-linejoin='round'><rect x='42' y='50' width='76' height='60' rx='8'/><circle cx='64' cy='72' r='7'/><path d='m46 106 26-24 18 16 12-10 14 14'/></g></svg>`
  );
